import type { DocumentoFCA } from "@/types/fca";

interface Props {
  documentos: DocumentoFCA[];
}

export default function TreeDocumentsTable({ documentos }: Props) {
  const formatDate = (dateStr: string) => {
    const [y, m, d] = dateStr.split("-");
    return `${d}/${m}/${y}`;
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-foreground-900 font-heading flex items-center gap-2">
          <i className="ri-file-list-3-line text-accent-500"></i>
          Documentos e Fontes Vinculadas
        </h3>
        <button className="btn-outline text-xs">
          <i className="ri-add-line"></i>
          Anexar documento
        </button>
      </div>
      <div className="bg-white rounded-card border border-background-200/70 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200 bg-background-50">
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Tipo</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Número</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Título</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Data</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Órgão / Emissor</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Status</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Ações</th>
              </tr>
            </thead>
            <tbody>
              {documentos.map((doc) => (
                <tr key={doc.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span className="badge bg-accent-100 text-accent-700">{doc.tipo}</span>
                  </td>
                  <td className="px-4 py-3 text-sm text-foreground-700 font-mono whitespace-nowrap">{doc.numero}</td>
                  <td className="px-4 py-3 text-sm text-foreground-900 max-w-[300px] truncate">{doc.titulo}</td>
                  <td className="px-4 py-3 text-sm text-foreground-700 whitespace-nowrap">{formatDate(doc.data)}</td>
                  <td className="px-4 py-3 text-sm text-foreground-600 max-w-[220px] truncate">{doc.emissor}</td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span className={`badge ${
                      doc.status === "Vigente" || doc.status === "Emitido" || doc.status === "Executada"
                        ? "bg-primary-100 text-primary-700"
                        : doc.status === "Anexado"
                        ? "bg-accent-100 text-accent-700"
                        : "bg-background-100 text-foreground-500"
                    }`}>
                      {doc.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-1">
                      <button className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-500 hover:text-accent-500 hover:bg-accent-50 transition-colors" title="Visualizar">
                        <i className="ri-eye-line text-sm"></i>
                      </button>
                      <button className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors" title="Download">
                        <i className="ri-download-line text-sm"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}